<template>
  <div class="overflow-hidden">
    <v-app-bar
      color="#1975d2"
      class="px-sm text-left shadow-sm"
      flat
      height="100"
      absolute
      prominent
    >
      <v-container class="d-flex align-center mt-2">
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="black"
        />
        <v-toolbar-title
          class="white--text p-t-10"
        >
          <a href="/">
            <v-img
              alt="VOD"
              class="shrink"
              contain
              src="/images/logo.png"
              transition="scale-transition"
              max-width="300"
            />
          </a>
        </v-toolbar-title>
        <v-spacer />
        <span class="white--text">
          Master VOD
        </span>
        <v-spacer />
        <v-menu
          offset-y
          right
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn
              color="white"
              v-bind="attrs"
              text
              v-on="on"
            >
              {{ username }}<v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout">
              <v-list-item-title>
                <v-icon class="mr-1">
                  mdi-logout
                </v-icon>Sign Out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
  export default {
    name: 'AppBar',
    data () {
      return {
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      username () {
        return this.$store.getters.getUsername ? this.$store.getters.getUsername : ''
      },
    },
    methods: {
      logout () {
        this.$store.dispatch('logout')
        this.$router.push({ name: 'SignIn' })
      },
    },
  }
</script>
